import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1d8b6ae0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "breadcrumbs" }
const _hoisted_2 = { class: "pvd3-list-group-root pvd-list-group--inline-always pvd-list-group--small" }
const _hoisted_3 = ["href", "id"]
const _hoisted_4 = {
  key: 0,
  class: "pvd3-list-group-root pvd-list-group--inline-always pvd-list-group--small"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_pvd3_link = _resolveComponent("pvd3-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("ul", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.linkList, (link) => {
        return (_openBlock(), _createElementBlock("li", {
          class: "pvd-list-group__list-item",
          key: link.index
        }, [
          _createElementVNode("a", {
            href: link.href,
            id: link.id
          }, _toDisplayString(link.text), 9, _hoisted_3)
        ]))
      }), 128))
    ]),
    (_ctx.showActionLinks)
      ? (_openBlock(), _createElementBlock("ul", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.actionsList, (link) => {
            return (_openBlock(), _createElementBlock("li", {
              class: "pvd-list-group__list-item action-item",
              key: link.index
            }, [
              _createVNode(_component_pvd3_link, {
                "pvd-class": "action-link",
                "pvd-icon-left": link.iconLeft,
                "pvd-href": link.href,
                "pvd-text": link.text,
                "pvd-disable-underline": ""
              }, null, 8, ["pvd-icon-left", "pvd-href", "pvd-text"])
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ]))
}